export default {
  supstockreport: {
    searchPlaceholder: '请输入料号或品名查询',
    supOfficeName: '供应商',
    purchaseDate: '采购日期',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    stockQty: '库存量',
    reportNo: '申报单号',
    purchaseNo: '订单号',
    editionNo: '版次号',
    adddate: '创建时间',
    officeNo: '供应商'
  },
  query: {
    searchPlaceholder: '请输入供应商/来源单号查询',
    orderType: '订单性质',
    purchaseNo: '采购单号',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    docDate: '单据日期',
    purOfficeName: '采购中心',
    supOfficeName: '供应商',
    sourceNo: '来源单号',
    sourceSeq: '来源项次',
    purchaseSeq: '项次',
    purchaseLineSeq: '项序',
    stockQty: '入库合格数量',
    purUnitName: '单位',
    valuationQty: '计价数量',
    valuationUnitName: '计价单位',
    unitPrice: '含税单价',
    taxIncludedAmount: '含税金额',
    taxAmount: '税额',
    taxTypeName: '税种',
    taxRate: '税率',
    currencyName: '币种',
    payTermsName: '付款条件',
    dataSource: '数据类型'
  }
}
